import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./auth/authSlice";
import { providerReducer } from "./provider/providerSlice";
import { connectionReducer } from "./connection/connectionSlice";
import { countryReducer } from "./country/countrySlice";
import { patientReducer } from "./patient/patientSlice";
import { insightsReducer } from "./patient/insights/insightsSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  provider: providerReducer,
  connection: connectionReducer,
  country: countryReducer,
  patient: patientReducer,
  insights: insightsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: import.meta.env.VITE_PROD_MODE === "false",
});

localStorage.removeItem("persist:root");
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
